export default "__VITE_ASSET__BO6C4Xjo__"